








































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';
import { Product } from '@/models/product';

@Component
export default class ListProduct extends Vue {
    @Prop({default: []})
    private order!: Order;

    get productsQuantity() {
        return this.order.products.reduce((total: number, prod: Product) => {
            return total + (prod.quantity || 0);
        }, 0);
    }

    get productsAmount() {
        return this.order.products.reduce((amount: number, prod: Product) => {
            return amount + (prod.quantity * (prod.pricePromotion || prod.priceOrigin));
        }, 0);
    }

    private onItemChange(productItem: any) {
        this.$emit('eventItemChange', productItem);
    }
    
    private onDeleteItem(productItem: any) {
        this.$emit('eventDeleteItem', productItem);
    }

    private onQuantityKeyDown(e: any) {
        if (e.key === '.' || e.key === '-') {
            e.preventDefault();
        }
        return;
    }
}
